import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-suc-filtred',
  templateUrl: './suc-filtred.component.html',
  styleUrls: ['./suc-filtred.component.scss']
})
export class SucFiltredComponent implements OnInit {
  @Input('data') public data: any;
  @Output() eventForm: EventEmitter<any> = new EventEmitter<any>();
  public objectEntries: any = Object.entries;
  constructor() { }

  ngOnInit() {
  }
  getAddress(sucursal) {
    return `${sucursal.calle} ${sucursal.numext}, Col. ${sucursal.colonia}, Del. ${sucursal.delegacion}`;
  }
  changeCollapse(index, status) {
    this.data[index].collapse = status;
  }
  sucursalSelected(data) {
    this.eventForm.emit(data);
  }

}
